import { api } from "../Configurations/axios";
import { AddressFinepTabTypesModel, AddressFinepModel } from "../Models/AddressFinepModel";


const GetAddressFinepByCompanyAndType = async (id: string, type: 'matrix' | 'branch' | 'correspondence') => {
    try {
        var result = await api.get(`/AddressFINEP/GetByCompanyFINEPId/${id}/${type}`);
        var response = result.data;
        return response.data;
    } catch(error: any) {
        throw new Error(error.response.data);
    }
}

const CreateAddressFinep = async (Address: AddressFinepModel) => {
    try {
        var result = await api.post(`/AddressFINEP/CreateAddressFINEP`, Address);
        var response = result.data;
        return response;
    } catch(error: any) {
        throw new Error(error.response.data);
    }
}

const EditAddressFinep = async (Address: AddressFinepModel) => {
    try {
        var result = await api.put(`/AddressFINEP/UpdateAddressFINEP`, Address);
        var response = result.data;
        return response;
    } catch(error: any) {
        throw new Error(error.response.data);
    }
}

interface ValidateAddressFinepProps{
    companyFINEPId: string;
    isContentValid: boolean;
    userEmail: string;
}

const ValidateAddressFinep = async (Address: ValidateAddressFinepProps) => {
    try {
        var result = await api.put(`/AddressFINEP/ValidateAddressFINEP`, Address);
        var response = result.data;
        return response;
    } catch(error: any) {
        throw new Error(error.response.data);
    }
}

export {
    GetAddressFinepByCompanyAndType,
    CreateAddressFinep,
    EditAddressFinep,
    ValidateAddressFinep
}